<template>
  <div 
    class="installment-item" 
    @click="handleClick(installment)"
  >
    <span class="installment-item-text">
      <span class="installment-item-label">
        {{ installment.label }}
      </span>
    </span>
    <span>{{ amountSpanContent }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ISuperPacmanInstallmentItem} from "@/types/ISuperPacman";
import { IInstallmentDetail } from '@/types/IInstallment';

export default defineComponent({
  name: "SuperPacmanInstallmentItem",
  props: {
    installment: {
      type: Object as PropType<ISuperPacmanInstallmentItem>,
      required: true
    },
  },
  emits: ["select-installment-item", "other-amount"],
  setup(props) {
    const store = useStore();
    const {t, n, locale} = useI18n();
    let amountSpanContent = "";

    if (Number(props.installment.amount) !== 0) {
      amountSpanContent = n(Number(props.installment.amount), 'currency', locale.value);
    } 

    return {
      t,
      n,
      locale,
      amountSpanContent,
      store
    };
  },
  methods: {
    handleClick(installment: ISuperPacmanInstallmentItem) {
      if (installment.amount == "0") {
        this.$emit("other-amount")
      } else {
        const baseInstallmentDetail: IInstallmentDetail = {
          amount: Number(installment.amount),
          term: installment.originalLabel,
          isOverPayment: false,
          days: 0
        }
        const acceptanceToken = this.store.state.payOptions.selectedInstallment?.acceptanceToken;
        this.store.dispatch("payOptions/setSelectedInstallment", baseInstallmentDetail)
        this.store.dispatch("payOptions/setWompiAcceptanceToken", acceptanceToken);
        this.store.dispatch("payOptions/setSuperPacmanAmount", Number(installment.amount))
        this.$emit("select-installment-item", installment)
      }
    }
  }
});
</script>

<style scoped>
.installment-item {
  display: flex;
  padding: 16px;
  margin-top: 15px;
  align-items: baseline;
  border-radius: 10px;
  border: 1px solid var(--Gray-elements-Border-1-inactive-botton);
  background: var(--main-white);
}

.installment-item:hover {
  background-color: #f0f0f0;
}

.installment-item-text {
  flex: 1 0 0;
  text-align: left;
  color: var(#111);
  font-feature-settings: "clig" off, "liga" off;
  /* Text regular-content-Page title */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 185.714% */
}

.installment-item-label {
  color: var(#666);
  font-feature-settings: "clig" off, "liga" off;

  /* Text regular-content-Page title */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}
</style>
